export default "__VITE_ASSET__ee19989a__"